import { render } from "./ActionsCol.vue?vue&type=template&id=5e972480&scoped=true"
import script from "./ActionsCol.vue?vue&type=script&lang=js"
export * from "./ActionsCol.vue?vue&type=script&lang=js"

import "./ActionsCol.vue?vue&type=style&index=0&id=5e972480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e972480"]])

export default __exports__